@if (busyIndicatorMessageManager.count() > 0) {
    <ws-busy-indicator [message]="busyIndicatorMessageManager.message"></ws-busy-indicator>
}

<ws-modal-wrapper headerLabel="Cap Rule"
                  [loading]="isLoading"
                  [hideSave]="true"
                  [excludeModalStyling]="true"
                  cancelLabel="Close"
                  (cancel)="close(true)">
    @if(capRuleForm) {
        <form name="capRuleForm" [formGroup]="capRuleForm" class="contact-form-modal mb-3" (ngSubmit)="save()">
            <div class="d-flex flex-column ws-stretch">
                <div class="ws-section">
                    <div class="ws-section__header">
                        <div class="ws-section__header__actions__right">
                            @if (canEdit) {
                                <div class="ws-section__header__actions__item">
                                    @if (!editMode && capRule) {
                                        <button
                                            type="button"
                                            class="ace-btn btn-sm btn-primary btn-success has-icon"
                                            (click)="recalculateCapComponents()"
                                            title="Starts a LRP to apply the rule">
                                            <i class="fa fa-refresh"></i>
                                        </button>
                                    }
                                    @if (!editMode) {
                                        <button
                                            type="button"
                                            class="ace-btn btn-sm btn-primary has-icon"
                                            (click)="goToEditMode()"
                                            title="Edit">
                                            <i class="fa fa-pencil"></i>
                                        </button>
                                    }
                                    @if (editMode) {
                                        <button
                                            type="button"
                                            class="ace-btn btn-sm btn-primary has-icon"
                                            (click)="save()"
                                            title="Save"
                                            [disabled]="saving || !canSave">
                                            <i class="fa fa-save"></i>
                                        </button>
                                    }
                                    @if (editMode && capRule) {
                                        <button
                                            type="button"
                                            class="ace-btn btn-sm btn-primary btn-danger has-icon"
                                            (click)="delete()"
                                            helpTooltip
                                            [helpContentId]="deleteHelp"
                                            [disabled]="saving || !canBeDeleted">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    }
                                    @if (editMode) {
                                        <button
                                            type="button"
                                            class="ace-btn btn-sm btn-primary btn-danger has-icon"
                                            (click)="cancel()"
                                            title="Cancel"
                                            [disabled]="saving">
                                            <i class="fa fa-close"></i>
                                        </button>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div class="d-flex">
                    <div class="d-flex flex-column flex-grow-1 me-3" style="height: initial;">
                        <div class="card panel-flat-color primary-panel m-0 pb-0 h-100">
                            <div class="panel-flat-header">
                                <h3>Info</h3>
                            </div>
                            <div class="panel-flat-body">
                                <div class="d-flex flex-column flex-grow-1 me-2">
                                    <div class="d-flex align-items-center">
                                        <label class="title">State:</label>
                                        <state-dropdown formControlName="stateId"
                                                        [includeBlank]="false"
                                                        [readOnly]="!editMode"
                                                        [filterByCountryId]="1"
                                                        styleClass="form-control form-select form-select-sm">
                                        </state-dropdown>
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <label class="title">Property Type:</label>
                                        @if (!editMode) {
                                            <span>{{ capRule?.propertyType }}</span>
                                        }
                                        @if (editMode) {
                                            <select formControlName="propertyTypeId"
                                                    class="form-control form-select form-select-sm">
                                                @for (type of propertyTypes; track type) {
                                                    <option [ngValue]="type.propertyTypeId">{{ type.name }}</option>
                                                }
                                            </select>
                                        }
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <label class="title">Assessment Component:</label>
                                        @if (!editMode) {
                                            <span>{{ capRule?.assessmentComponentName }}</span>
                                        }
                                        @if (editMode) {
                                            <select formControlName="assessmentComponentId"
                                                    class="form-control form-select form-select-sm">
                                                @for (component of assessmentComponents; track component) {
                                                    <option [ngValue]="component.assessmentComponentID">{{ component.componentName }}</option>
                                                }
                                            </select>
                                        }
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <label class="title">Tax Year Begin:</label>
                                        @if (!editMode) {
                                            <span>{{ capRule?.taxYearBegin || 'Infinite' }}</span>
                                        }
                                        @if (editMode) {
                                            <input type="number"
                                                   [numbersOnly]="true"
                                                   [negativeAllowed]="false"
                                                   formControlName="taxYearBegin"
                                                   class="form-control my-1">
                                        }
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <label class="title">Tax Year End:</label>
                                        @if (!editMode) {
                                            <span>{{ capRule?.taxYearEnd || 'Infinite'  }}</span>
                                        }
                                        @if (editMode) {
                                            <input type="number"
                                                   [numbersOnly]="true"
                                                   formControlName="taxYearEnd"
                                                   class="form-control my-1">
                                        }
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <label class="title">Pre-Defined Rule:</label>
                                        @if (!editMode) {
                                            <span>{{ capRule?.capRulePredefinedName }}</span>
                                        }
                                        @if (editMode) {
                                            <select formControlName="capRulePredefinedId"
                                                    class="form-control form-select form-select-sm">
                                                @for (rule of predefinedRules; track rule) {
                                                    <option [ngValue]="rule.capRulePredefinedId">{{ rule.name }}</option>
                                                }
                                            </select>
                                        }
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <label class="title">Cap Value Range (Max):</label>
                                        @if (!editMode && capRule?.capValueRange) {
                                            <span>Calc cap amt < {{ capRule?.capValueRange | number: '1.0-0'}}</span>
                                        }
                                        @if (editMode) {
                                            <input type="number"
                                                   [numbersOnly]="true"
                                                   formControlName="capValueRange"
                                                   class="form-control my-1">
                                        }
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <label class="title">Cap May Exceed AV:</label>
                                        @if (!editMode) {
                                            <span>{{ capRule?.mayCapExceedAV ? 'Yes' : 'No' }}</span>
                                        }
                                        @if (editMode) {
                                            <div class="checkbox">
                                                <label>
                                                    <input type="checkbox" formControlName="mayCapExceedAV">Cap May Exceed AV
                                                </label>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex flex-column flex-grow-1 me-3">
                        <div class="card panel-flat-color primary-panel m-0 pb-0 h-100"
                             style="padding-bottom: 0; width: initial;">
                            <div class="panel-flat-header" style="margin-bottom: 0;">
                                <h3>Annual Percent Increase</h3>
                            </div>
                            <div class="panel-flat-body d-flex flex-column" style="justify-content: space-between; ">
                                <div>
                                    <div class="d-flex ws-flex-align-items-center">
                                        <label class="title" style="min-width: 90px;">Default (%):</label>
                                        @if (!editMode) {
                                            <span>{{ capRule?.defaultAnnualPercentIncrease * 100 }}</span>
                                        }
                                        @if (editMode) {
                                            <input type="number"
                                                   [numbersOnly]="true"
                                                   [negativeAllowed]="false"
                                                   formControlName="defaultAnnualPercentIncrease"
                                                   class="form-control my-1 ws-text-align-right">
                                        }
                                    </div>
                                </div>
                                <div style="height:100%; max-height: 300px; overflow: auto; margin: 10px 0;">
                                    <table class="table table-condensed">
                                        <thead>
                                        <tr>
                                            <th>Tax Year</th>
                                            <th style="text-align: right;">Rate</th>
                                            @if(editMode) {
                                                <th>&nbsp;</th>
                                            }
                                        </tr>
                                        </thead>
                                        <tbody formArrayName="annualPercentIncreases">
                                            @for (yearGroup of fAnnualPercentIncreases.controls; track yearGroup;) {
                                                <tr [formGroup]="$any(yearGroup)">
                                                    <td>{{$any(yearGroup).controls.year.value}}</td>
                                                    @if (!editMode) {
                                                        <td style="text-align: right;">{{$any(yearGroup).controls.value.value}}</td>
                                                    }
                                                    @if (editMode) {
                                                        <td style="text-align: right;">
                                                            <input
                                                                type="number"
                                                                [numbersOnly]="true"
                                                                [negativeAllowed]="false"
                                                                class="form-control ws-text-align-right"
                                                                formControlName="value">
                                                        </td>
                                                    }
                                                    @if (editMode) {
                                                        <td style="vertical-align: middle">
                                                            <button
                                                                class="ace-btn has-icon btn-primary btn-danger btn-sm m-0"
                                                                type="button"
                                                                (click)="removeIncrease($any(yearGroup).controls.year.value)">
                                                                <i class="fa fa-trash clickable"></i>
                                                            </button>
                                                        </td>
                                                    }
                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                @if (editMode) {
                                    <div>
                                        <button type="button"
                                                class="ace-btn btn-primary btn-sm"
                                                (click)="launchAddTaxYearModal()">
                                            Add Tax Year
                                        </button>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    }
</ws-modal-wrapper>
